import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2714aea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("当前：")
const _hoisted_4 = { class: "page_info_nr" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item_label" }
const _hoisted_7 = { class: "item_label1" }
const _hoisted_8 = {
  key: 0,
  class: "green"
}
const _hoisted_9 = {
  key: 1,
  class: "yellow"
}
const _hoisted_10 = {
  key: 2,
  class: "red"
}
const _hoisted_11 = { class: "item_label2" }

import { ref, onMounted, reactive } from 'vue'
    import { useRoute } from "vue-router"
    import { pageForH5, pageHW } from '@/apis/WorkOrderAPI'
    import { getLocationInfo } from '@/apis/ExWarehouse'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const form = reactive({
        capacity: 10,
        page: 0
    })

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)

    // 货位信息
    let info = ref({})

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        getList()
    }

    // 通过货位id获取id详情
    const getLocation = () => {
        pageHW({
            capacity: 1,
            page: 1,
            model: {
                id: route.query.id
            }
        })
            .then(res => {
                if (res.code === 200) {
                    info.value = res.data.records[0]
                }
            })
    }

    const getList = () => {
        if (!finished.value) {
            loading.value = true;
            form.page = form.page + 1
            pageForH5({
                capacity: form.capacity,
                page: form.page,
                model: {
                    locationId: route.query.id,
                    groupType: 3,
                    greaterZero: 1
                }
            }).then(res => {
                loading.value = false;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true;
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    onMounted(() => {
        getList()
        getLocation()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(info).wmodel)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_unref(info).wmodel.name), 1)
          ], 64))
        : _createCommentVNode("", true),
      _createTextVNode(" / " + _toDisplayString(_unref(info).unionName), 1)
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: getList
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "page_info",
                key: index
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                    _createElementVNode("div", _hoisted_7, [
                      (item.qualityType === '0')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "合格"))
                        : _createCommentVNode("", true),
                      (item.qualityType === '1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "不良"))
                        : _createCommentVNode("", true),
                      (item.qualityType === '2')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "报废"))
                        : _createCommentVNode("", true),
                      _createTextVNode(" | " + _toDisplayString(item.procedureName ? item.procedureName : '-') + " | " + _toDisplayString(item.batch ? item.batch : '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, "数量：" + _toDisplayString(item.num) + _toDisplayString(item.unitName), 1)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})